'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$Hero(pill, heading, sub, socialProof, trio, noSecondary, imgAlt) {
  this.gs = null;
  this.ek = null;
  this.gu = null;
  this.gt = null;
  this.fC = null;
  this.gr = false;
  this.gq = null;
  this.gs = pill;
  this.ek = heading;
  this.gu = sub;
  this.gt = socialProof;
  this.fC = trio;
  this.gr = noSecondary;
  this.gq = imgAlt;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$Hero as $c_Lio_intela_sites_digitalinternship_data_Segments$Hero };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$Hero.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$Hero;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$Hero() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$Hero as $h_Lio_intela_sites_digitalinternship_data_Segments$Hero };
$h_Lio_intela_sites_digitalinternship_data_Segments$Hero.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, 2245658);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gs));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.ek));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gu));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gt));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.fC));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.gr ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gq));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().Q(acc, 7);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$Hero)) {
    if ((this.gr === x$0.gr)) {
      var x = this.gs;
      var x$2 = x$0.gs;
      var $x_4 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.ek;
      var x$4 = x$0.ek;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.gu === x$0.gu))) {
      var x$5 = this.gt;
      var x$6 = x$0.gt;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.fC;
      var x$8 = x$0.fC;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.gq;
      var x$10 = x$0.gq;
      return ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 7;
});
$p.I = (function() {
  return "Hero";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.gs;
      break;
    }
    case 1: {
      return this.ek;
      break;
    }
    case 2: {
      return this.gu;
      break;
    }
    case 3: {
      return this.gt;
      break;
    }
    case 4: {
      return this.fC;
      break;
    }
    case 5: {
      return this.gr;
      break;
    }
    case 6: {
      return this.gq;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Hero(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bz)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Hero as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Hero };
var $d_Lio_intela_sites_digitalinternship_data_Segments$Hero = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$Hero, "io.intela.sites.digitalinternship.data.Segments$Hero", ({
  bz: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$Hero as $d_Lio_intela_sites_digitalinternship_data_Segments$Hero };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Hero.js.map
